import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ContactBulkMessageModule } from '../contact-bulk-message/contact-bulk-message.module';
import { ContactsInactivesBannerComponent } from './contacts-inactives-banner.component';

@NgModule({
	declarations: [ContactsInactivesBannerComponent],
	imports: [CommonModule, ContactBulkMessageModule, TranslateModule.forChild()],
	exports: [ContactsInactivesBannerComponent],
	providers: [],
})
export class ContactsInactivesBannerModule {}
